/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
import Comment from '@linc-technologies/linced-common/models/posts/comment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Communitynotice from 'linced-app/models/posts/communitynotice';
import type Staffnotice from 'linced-app/models/posts/staffnotice';
import type Studentnotice from 'linced-app/models/posts/studentnotice';
import type Text from 'linced-app/models/posts/text';

// Proto: posts.Comment.
export default class _Comment extends Comment {
  declare [Type]: 'posts/comment';

  @belongsTo('posts/communitynotice', { async: true, inverse: 'comments' })
  declare communityNoticeId: AsyncBelongsTo<Communitynotice>;

  @belongsTo('posts/studentnotice', { async: true, inverse: 'comments' })
  declare studentNoticeId: AsyncBelongsTo<Studentnotice>;

  @belongsTo('posts/staffnotice', { async: true, inverse: 'comments' })
  declare staffNoticeId: AsyncBelongsTo<Staffnotice>;

  @belongsTo('posts/text', { async: true, inverse: 'comments' })
  declare textId: AsyncBelongsTo<Text>;

  @computed('postType')
  // @ts-expect-error a getter for the post by type replaces the common
  // postId alias.
  get post() {
    switch (this.postType) {
      case PostTypes.COMMUNITY_NOTICE:
        return this.communityNoticeId;
      case PostTypes.STUDENT_NOTICE:
        return this.studentNoticeId;
      case PostTypes.STAFF_NOTICE:
        return this.staffNoticeId;
      case PostTypes.TEXT:
        return this.textId;
      default:
        return this.postId;
    }
  }
}
